import React from 'react';
import { View, TouchableOpacity, Image } from 'react-native';
import Typography from 'src/components/Text/Text';
import BottomModal from 'src/components/BottomModal/BottomModal';
import { styles } from './QuoteMethodModal.styles';
import headPhoneIcon from 'src/assets/headphone.png';
import quoteIcon from 'src/assets/text.png';
import arrowRight from 'src/assets/filled_arrow_right.png';
import closeIcon from 'src/assets/close_plain.png';
import { useAddDataFilledByMutation } from 'src/features/company/api/companyApi';
import { trackGTMEvent } from 'src/helpers/gtm/gtmEvents';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
interface QuoteMethodModalProps {
  isVisible: boolean;
  onClose: () => void;
  setQuoteSuccessVisible: (visible: boolean) => void;
  navigateToVehiclesTab?: () => void;
  companyId: number;
}

const QuoteMethodModal: React.FC<QuoteMethodModalProps> = ({
  isVisible,
  onClose,
  setQuoteSuccessVisible,
  navigateToVehiclesTab,
  companyId,
}) => {
  const [addDataFilledBy] = useAddDataFilledByMutation();
  const accountType = useSelector((state: RootState) => state.UI.accountType);
  //I want to use this mutation and send filled by and call it onPress
  const handleSelectAgent = (filledBy: string) => {
    addDataFilledBy({ companyId: companyId, dataFilledBy: filledBy });
    onClose();
    if (filledBy === 'Producer') {
      setQuoteSuccessVisible(true);
    } else {
      if (navigateToVehiclesTab) {
        navigateToVehiclesTab();
      }
    }
    const eventName =
      filledBy === 'Producer' ? 'user-selected-quote-by-producer' : 'user-selected-quote-on-own';
    trackGTMEvent(
      eventName,
      {
        userEvent: 'User selected data filled by modal option.',
      },
      accountType,
    );
  };
  return (
    <BottomModal
      closeIcon={closeIcon}
      isVisible={isVisible && accountType !== 'producer'}
      onClose={onClose}
      title=""
      style={styles.container}>
      <View style={styles.innerContainer}>
        <TouchableOpacity
          style={styles.optionCard}
          testID="quote-method-talkto-specialist"
          onPress={() => {
            handleSelectAgent('Producer');
          }}>
          <Image source={arrowRight} style={styles.arrowIcon} />
          <Image source={headPhoneIcon} style={styles.optionIcon} />
          <View style={styles.optionTextContainer}>
            <Typography variant="h3" style={styles.title}>
              Talk to a Trucking Insurance Specialist
            </Typography>
            <Typography variant="body1" style={styles.description}>
              Get help from an expert to find the right coverage.
            </Typography>
          </View>
        </TouchableOpacity>

        <TouchableOpacity
          testID="quote-method-doit-yourself"
          style={styles.optionCard}
          onPress={() => {
            handleSelectAgent('User');
          }}>
          <Image source={arrowRight} style={styles.arrowIcon} />
          <Image source={quoteIcon} style={styles.optionIcon} />
          <View style={styles.optionTextContainer}>
            <Typography variant="h3" style={styles.title}>
              Get a Quote on Your Own
            </Typography>
            <Typography variant="body1" style={styles.description}>
              No agent involved — click here to get your quote instantly.
            </Typography>
          </View>
        </TouchableOpacity>
      </View>
    </BottomModal>
  );
};

export default QuoteMethodModal;
